import { useEffect, useRef, useState } from 'react';

export function ValorAnimado({ de = 0, para = 0, duracao = 800 }) {
    const [valor, setValor] = useState(de);
    const rafRef = useRef(null);

    useEffect(() => {
        const inicio = performance.now();

        const animar = (agora) => {
            const progresso = Math.min((agora - inicio) / duracao, 1);
            const valorAtual = de + (para - de) * progresso;
            setValor(valorAtual);
            if (progresso < 1) {
                rafRef.current = requestAnimationFrame(animar);
            }
        };

        rafRef.current = requestAnimationFrame(animar);

        return () => cancelAnimationFrame(rafRef.current);
    }, [de, para, duracao]);

    const formatado = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(valor);

    return <>{formatado}</>;
}

export function QuantidadeAnimada({ de = 0, para = 0, duracao = 800 }) {
    const [valor, setValor] = useState(de);
    const rafRef = useRef(null);

    useEffect(() => {
        const inicio = performance.now();

        const animar = (agora) => {
            const progresso = Math.min((agora - inicio) / duracao, 1);
            const valorAtual = de + (para - de) * progresso;
            setValor(valorAtual);
            if (progresso < 1) {
                rafRef.current = requestAnimationFrame(animar);
            }
        };

        rafRef.current = requestAnimationFrame(animar);

        return () => cancelAnimationFrame(rafRef.current);
    }, [de, para, duracao]);

    return <>{Math.round(valor).toLocaleString('pt-BR')}</>;
}